import FormAutoComplete from './FormAutoComplete'

export default FormAutoComplete
